import { PassengerSelectedGdsServicesFragment } from '@websky/graphql';
import { ButtonVariant } from '../BaseComponents/Button/types';

export interface ServiceButton {
	className?: string;
	text: string;
	action: () => void;
	isLoading?: boolean;
	buttonType?: 'change' | 'info';
	variant?: ButtonVariant;
}

export enum AdditionalServiceType {
	Seat,
	Meal,
	Baggage,
	Transfer,
	Insurance,
	BusinessLounge,
	PriorityBoarding
}

export interface SelectedService extends PassengerSelectedGdsServicesFragment {
	passengerId: string;
	segmentId: string;
}
